import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, i) => ({
    '@type': 'ListItem' as const,
    position: i + 1,
    item: item.href
      ? { '@id': `https://www.kaiyunsports.com${item.href}`, name: item.label }
      : { name: item.label },
  }));

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}